<ph-stack gap="tight">
    <ph-label *ngIf="section.label">{{ section.label }}</ph-label>
    <div class="ap-table-rows">
        <ph-list-row *ngFor="let row of listRows; trackBy: trackByIndex"
                     [heading]="row.heading"
                     [meta]="row.meta"></ph-list-row>
    </div>
    <ph-link-button *ngIf="collapsible" class="ap-table-toggle" variant="primary" size="small" (click)="showAll = !showAll">
        {{ showAll ? 'Show fewer' : 'Show all ' + rows.length + ' rows' }}
    </ph-link-button>
</ph-stack>
